import * as types from './mutation-types';

export const closeAll = async ({ commit }) => { commit(types.CLOSE_ALL) };
export const closeRight = async ({ commit }) => { commit(types.CLOSE_RIGHT) };
export const closeCenter = async ({ commit }) => { commit(types.CLOSE_CENTER) };

export const showToast = async ({ commit, dispatch }, { id }) => {
    commit(types.NOTIFICATION_TOAST, { visible: true, id });

    await dispatch('hideToast');
};

export const hideToast = ({ commit }) => {
    return new Promise((resolve) => {
        let timer = setTimeout(() => {
            commit(types.NOTIFICATION_TOAST, { visible: false });
            resolve();
            clearTimeout(timer);
        }, 4000);
    });
};

export const showResetPasswordForm = ({ commit, dispatch }) => {
    dispatch('closeRight');
    commit(types.RESET_PASSWORD_FORM, true)
};

export const hideResetPasswordForm = ({ commit }) => {
    commit(types.RESET_PASSWORD_FORM, false)
};

export const showRecoverPasswordForm = ({ commit, dispatch }) => {
    dispatch('closeRight');
    commit(types.RECOVER_PASSWORD_FORM, true)
};

export const hideRecoverPasswordForm = ({ commit }) => {
    commit(types.RECOVER_PASSWORD_FORM, false)
};

export const showSignInForm = ({ commit, dispatch }) => {
    dispatch('closeRight');
    commit(types.SIGN_IN_FORM, true)
};

export const hideSignInForm = ({ commit }) => {
    commit(types.SIGN_IN_FORM, false)
};

export const showSettingsForm = ({ commit, dispatch }) => {
    dispatch('closeCenter');
    commit(types.SETTINGS_FORM, true)
};

export const hideSettingsForm = ({ commit }) => {
    commit(types.SETTINGS_FORM, false)
};

export const showSelectPictureForm = ({ commit, dispatch }) => {
    dispatch('closeCenter');
    commit(types.SELECT_PICTURE_FORM, true)
};

export const hideSelectPictureForm = ({ commit }) => {
    commit(types.SELECT_PICTURE_FORM, false)
};

export const backToSettingsForm = ({ commit, dispatch }) => {
    console.log('ss');
    dispatch('closeCenter');
    commit(types.SETTINGS_FORM, true);
};

export const showProfileForm = ({ commit, dispatch }) => {
    dispatch('closeRight');
    commit(types.PROFILE_FORM, true)
};

export const hideProfileForm = ({ commit }) => {
    commit(types.PROFILE_FORM, false)
};

export const showNotifications = ({ commit, dispatch }) => {
    dispatch('closeRight');
    commit(types.NOTIFICATIONS_LIST, true)
};

export const hideNotifications = ({ commit }) => {
    commit(types.NOTIFICATIONS_LIST, false)
};


export default {
    closeAll,
    closeRight,
    closeCenter,
    showToast,
    hideToast,
    showResetPasswordForm,
    hideResetPasswordForm,
    showRecoverPasswordForm,
    hideRecoverPasswordForm,
    showProfileForm,
    hideProfileForm,
    showSignInForm,
    hideSignInForm,
    showSettingsForm,
    hideSettingsForm,
    backToSettingsForm,
    showSelectPictureForm,
    hideSelectPictureForm,
    showNotifications,
    hideNotifications,
};



// WEBPACK FOOTER //
// ./src/store/modules/navbar/actions.js